// import React, { useEffect } from 'react'

// const UploadFilePreview = (props:any) => {
//     const {file,filePath,RemoveImg,setFile}=props;
//     useEffect(() => {
//         return () => {}
//     }, [])
//     return (
//         <>
//            {file && filePath && file?.length > 0 &&
//             <div className="form-group d-flex flex-row flex-wrap">
//                 {file && filePath && file.length> 0 && file?.map((img:any, i:any)=> {let fileUrl:any=`${filePath}${img}`; return (
//                     <div className="m-1" style={{position: "relative", border: "1px solid #000"}} key={i}>
//                         <button type="button" className="close AClass" onClick={()=>RemoveImg(img)}>
//                         <span>&times;</span>
//                         </button>
//                         {["pdf", "docx","doc"].includes(fileUrl?.split(".")?.pop()) ?
//                         <a href={img && fileUrl} target="_blank" className="f-14" ><div style={{width: "90px", height: "100px", overflow:"hidden", padding: "2px", wordBreak: "break-all"}}>{img}</div></a>
//                         :
//                         <a href={img && fileUrl} target="_blank"><img src={img && fileUrl} alt="" style={{width: "90px", height: "100px"}}/></a>
//                         }
//                     </div>
//                 )})}
//             </div>
//             }
//         </>
//     )
// }

// export default UploadFilePreview

import React from "react";

interface UploadFilePreviewProps {
  file: string[];
  filePath: string;
  RemoveImg: (fileName: string) => void;
  setFile: (files: string[]) => void;
}

const UploadFilePreview: React.FC<UploadFilePreviewProps> = ({
  file,
  filePath,
  RemoveImg,
  setFile,
}) => {
  const handleRemoveAll = () => {
    setFile([]);
  };

  if (!file || file.length === 0 || !filePath) return null;

  return (
    <div className="mt-3">
      <div className="mb-2 d-flex align-items-center">
        <span className="text-success fw-bold me-2">
          {file.length === 1
            ? `File 1 uploaded`
            : `Files 1 to ${file.length} uploaded`}
        </span>
        {/* <button
          type="button"
          className="btn btn-sm btn-outline-danger"
          style={{marginLeft:'30px'}}
          onClick={handleRemoveAll}
        >
          Remove All
        </button> */}
      </div>

      <div className="form-group d-flex flex-row flex-wrap">
        {file.map((img: string, i: number) => {
          const fileUrl = `${filePath}${img}`;
          const fileExt = fileUrl.split(".").pop()?.toLowerCase();

          return (
            <div
              key={i}
              className="position-relative m-1 p-2"
              style={{
                border: "1px solid #ccc",
                borderRadius: "5px",
                width: "100px",
              }}
            >
              <button
                type="button"
                className="close AClass"
                onClick={() => RemoveImg(img)}
              >
                <span>&times;</span>
              </button>
              <div className="text-center" style={{ fontSize: "12px" }}>
                File {i + 1}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default UploadFilePreview;
